import { I as M, a as Q, l as U, n as V, c as Z } from "./index2.js";
var k = Object.prototype.toString, T = function(r) {
  var a = k.call(r), t = a === "[object Arguments]";
  return t || (t = a !== "[object Array]" && r !== null && typeof r == "object" && typeof r.length == "number" && r.length >= 0 && k.call(r.callee) === "[object Function]"), t;
}, $, D;
function C() {
  if (D)
    return $;
  D = 1;
  var i;
  if (!Object.keys) {
    var r = Object.prototype.hasOwnProperty, a = Object.prototype.toString, t = T, u = Object.prototype.propertyIsEnumerable, o = !u.call({ toString: null }, "toString"), f = u.call(function() {
    }, "prototype"), p = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], v = function(n) {
      var e = n.constructor;
      return e && e.prototype === n;
    }, s = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, l = function() {
      if (typeof window > "u")
        return !1;
      for (var n in window)
        try {
          if (!s["$" + n] && r.call(window, n) && window[n] !== null && typeof window[n] == "object")
            try {
              v(window[n]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), c = function(n) {
      if (typeof window > "u" || !l)
        return v(n);
      try {
        return v(n);
      } catch {
        return !1;
      }
    };
    i = function(e) {
      var P = e !== null && typeof e == "object", I = a.call(e) === "[object Function]", A = t(e), _ = P && a.call(e) === "[object String]", y = [];
      if (!P && !I && !A)
        throw new TypeError("Object.keys called on a non-object");
      var G = f && I;
      if (_ && e.length > 0 && !r.call(e, 0))
        for (var b = 0; b < e.length; ++b)
          y.push(String(b));
      if (A && e.length > 0)
        for (var m = 0; m < e.length; ++m)
          y.push(String(m));
      else
        for (var O in e)
          !(G && O === "prototype") && r.call(e, O) && y.push(String(O));
      if (o)
        for (var J = c(e), g = 0; g < p.length; ++g)
          !(J && p[g] === "constructor") && r.call(e, p[g]) && y.push(p[g]);
      return y;
    };
  }
  return $ = i, $;
}
var rr = Array.prototype.slice, er = T, E = Object.keys, h = E ? function(r) {
  return E(r);
} : C(), q = Object.keys;
h.shim = function() {
  if (Object.keys) {
    var r = function() {
      var a = Object.keys(arguments);
      return a && a.length === arguments.length;
    }(1, 2);
    r || (Object.keys = function(t) {
      return er(t) ? q(rr.call(t)) : q(t);
    });
  } else
    Object.keys = h;
  return Object.keys || h;
};
var z = h, tr = z, L = M(), N = Q, x = Object, nr = N("Array.prototype.push"), B = N("Object.prototype.propertyIsEnumerable"), ir = L ? Object.getOwnPropertySymbols : null, ar = function(r, a) {
  if (r == null)
    throw new TypeError("target must be an object");
  var t = x(r);
  if (arguments.length === 1)
    return t;
  for (var u = 1; u < arguments.length; ++u) {
    var o = x(arguments[u]), f = tr(o), p = L && (Object.getOwnPropertySymbols || ir);
    if (p)
      for (var v = p(o), s = 0; s < v.length; ++s) {
        var l = v[s];
        B(o, l) && nr(f, l);
      }
    for (var c = 0; c < f.length; ++c) {
      var n = f[c];
      if (B(o, n)) {
        var e = o[n];
        t[n] = e;
      }
    }
  }
  return t;
}, j = ar, or = function() {
  if (!Object.assign)
    return !1;
  for (var i = "abcdefghijklmnopqrst", r = i.split(""), a = {}, t = 0; t < r.length; ++t)
    a[r[t]] = r[t];
  var u = Object.assign({}, a), o = "";
  for (var f in u)
    o += f;
  return i !== o;
}, sr = function() {
  if (!Object.assign || !Object.preventExtensions)
    return !1;
  var i = Object.preventExtensions({ 1: 2 });
  try {
    Object.assign(i, "xy");
  } catch {
    return i[1] === "y";
  }
  return !1;
}, fr = function() {
  return !Object.assign || or() || sr() ? j : Object.assign;
}, F = function(i) {
  return i !== i;
}, W = function(r, a) {
  return r === 0 && a === 0 ? 1 / r === 1 / a : !!(r === a || F(r) && F(a));
}, ur = W, X = function() {
  return typeof Object.is == "function" ? Object.is : ur;
}, d, K;
function Y() {
  if (K)
    return d;
  K = 1;
  var i = z, r = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", a = Object.prototype.toString, t = Array.prototype.concat, u = V, o = function(s) {
    return typeof s == "function" && a.call(s) === "[object Function]";
  }, f = U(), p = function(s, l, c, n) {
    if (l in s) {
      if (n === !0) {
        if (s[l] === c)
          return;
      } else if (!o(n) || !n())
        return;
    }
    f ? u(s, l, c, !0) : u(s, l, c);
  }, v = function(s, l) {
    var c = arguments.length > 2 ? arguments[2] : {}, n = i(l);
    r && (n = t.call(n, Object.getOwnPropertySymbols(l)));
    for (var e = 0; e < n.length; e += 1)
      p(s, n[e], l[n[e]], c[n[e]]);
  };
  return v.supportsDescriptors = !!f, d = v, d;
}
var w, R;
function lr() {
  if (R)
    return w;
  R = 1;
  var i = X, r = Y();
  return w = function() {
    var t = i();
    return r(Object, { is: t }, {
      is: function() {
        return Object.is !== t;
      }
    }), t;
  }, w;
}
var S, H;
function pr() {
  if (H)
    return S;
  H = 1;
  var i = Y(), r = Z, a = W, t = X, u = lr(), o = r(t(), Object);
  return i(o, {
    getPolyfill: t,
    implementation: a,
    shim: u
  }), S = o, S;
}
export {
  pr as a,
  X as b,
  ar as i,
  z as o,
  fr as p,
  Y as r
};
